import { cn } from "@omni/utils/styles";
import { useState } from "react";
import { SingleValue } from "react-select";

import { Select } from "@/components/Form/Base/select.component";

import { useProductSortContext } from "../../context/sort.context";
import { SortItem } from "../../sort.types";

type SortComponentProps = {
    className?: string;
    renderOption?: (option: SortItem) => React.ReactNode;
};

const SortList = ({ renderOption, className }: SortComponentProps) => {
    const { refinedItem, items, onRefine: refine } = useProductSortContext();

    const [optimisticValue, setOptimisticValue] = useState<
        SortItem | undefined
    >(refinedItem);

    const handleOnSelectChange = (option: SingleValue<SortItem>) => {
        if (!option) return;

        setOptimisticValue(option);
        refine(option.value);
    };

    return (
        <Select
            className={cn("tw:min-w-50", className)}
            openMenuOnFocus={true}
            classNamePrefix="select-box"
            options={items}
            isSearchable={false}
            blurInputOnSelect={true}
            value={optimisticValue}
            onChange={handleOnSelectChange}
            formatOptionLabel={renderOption}
        />
    );
};

export { SortList };
